import { SideNavigationItemType } from './SideNavigation';

const safeGetPathname = (url: string) => {
  try {
    return new URL(url).pathname;
  } catch {
    // ignore
  }
  return url;
};

export const isActive = (item: SideNavigationItemType, selectedId?: string) => {
  const pathname = window.location.pathname;

  if (item.loading) return false;

  if (selectedId) {
    return item.id === selectedId || item.key === selectedId;
  }
  if (!item.url) return false;

  return pathname.startsWith(safeGetPathname(item.url));
};
